"use client";

import { isOptedOutCCPA } from "@/app/_utilities/ccpa";
import { LocalStorageKeys, safeLocalStorage } from "@utilities/localStorage";
import { logger } from "@utilities/logger";
import Cookies from "js-cookie";
import { useEffect } from "react";

declare global {
  interface Window {
    growsumo?: any;
  }
}

const REFERRAL_KEY_URL_PARAM_NAME = "from";

export const usePartnersStack = () => {
  useEffect(() => {
    if (isOptedOutCCPA()) {
      return;
    }
    try {
      installPartnerStack();
    } catch (e) {
      logger.error(e instanceof Error ? e : null, "PartnerStack install failed");
    }
  }, []);
};

export const installPartnerStack = () => {
  // There are two kinds of referral links we use for tracking to Partner Stack
  // Native Partner Stack links use GrowSumo cookie
  //
  // In addition, to improve SEO we generate links and track customer signups manually using localstorage and Partner Stack partner keys
  // This is to improve SEO performance
  //
  // We should only have one referral cookie alive at a time
  installGrowSumoCookie();
  storeReferralLinkInLocalStorage();
};

export const installGrowSumoCookie = () => {
  const { head } = document;
  const script1 = document.createElement("script");
  script1.innerText =
    "(function() {var gs = document.createElement('script');gs.src = 'https://try.elevenlabs.io/pr/js';gs.type = 'text/javascript';gs.async = 'true';gs.onload = gs.onreadystatechange = function() {var rs = this.readyState;if (rs && rs != 'complete' && rs != 'loaded') return;try {growsumo._initialize('pk_KEommGpdHbee56mN5pTwtbJiHJNfxzKP'); if (typeof(growsumoInit) === 'function') {growsumoInit();}} catch (e) {}};var s = document.getElementsByTagName('script')[0];s.parentNode.insertBefore(gs, s);})();";
  head.insertBefore(script1, head.firstChild);
};

export const storeReferralLinkInLocalStorage = () => {
  const referralUrl = new URL(window.location.href);
  // if try PartnerStack referral link, remove all referral links
  if (referralUrl.searchParams.has("ps_partner_key")) {
    if (typeof document !== "undefined" && typeof window !== "undefined") {
      safeLocalStorage.removeItem(LocalStorageKeys.REFERRAL_LINK);
      return;
    }
  }

  // If via present then overwrite local storage and delete grow sumo cookie
  if (referralUrl.searchParams.has(REFERRAL_KEY_URL_PARAM_NAME)) {
    removeGrowSumoCookie();
    const expiresTimestamp = new Date().getTime() + 90 * 24 * 60 * 60 * 1000;
    const viaReferralLink = { value: referralUrl.searchParams.get(REFERRAL_KEY_URL_PARAM_NAME), expiresTimestamp };
    safeLocalStorage.setItem(LocalStorageKeys.REFERRAL_LINK, JSON.stringify(viaReferralLink));
  }
};

function removeGrowSumoCookie() {
  if (typeof document === "undefined") {
    return;
  }
  if (typeof window === "undefined") {
    return;
  }
  setTimeout(() => {
    Cookies.remove("growSumoPartnerKey", {
      path: "/",
      domain: window.location.hostname,
    });
    Cookies.remove("ps_partner_key", {
      path: "/",
      domain: window.location.hostname,
    });
    Cookies.remove("ps_xid", {
      path: "/",
      domain: window.location.hostname,
    });
    if (window.growsumo) {
      window.growsumo = null;
    }
    logger.info("Deleted referral cookie as visit came from Google Ads (forbidden by Terms of Service)");
  }, 2000);
}
